import React from "react";
import { parseISO } from "date-fns";

const dateFormatter = new Intl.DateTimeFormat(undefined, {
  dateStyle: "medium",
});
const dateTimeFormatter = new Intl.DateTimeFormat(undefined, {
  dateStyle: "medium",
  timeStyle: "medium",
});

export default function DateTime({ date, formatDateTime }: Props) {
  if (date == null) {
    return null;
  }

  const dateObjectOrNumber = typeof date === "string" ? parseISO(date) : date;

  const contentFormatter = formatDateTime ? dateTimeFormatter : dateFormatter;

  return (
    <time
      title={
        !formatDateTime
          ? dateTimeFormatter.format(dateObjectOrNumber)
          : undefined
      }
    >
      {contentFormatter.format(dateObjectOrNumber)}
    </time>
  );
}

type Props = {
  date?: string | Date | null;
  formatDateTime?: boolean;
};
